import React, { useEffect, useState } from 'react'
import Navbar from '../components/Navbar.js';
import Sidebar from '../components/Sidebar.js';
import { useNavigate } from "react-router-dom";
import { Globals } from '../globalfunctions.js';
import { apiClient } from '../utils/apiClient';
import styles from './Sales.module.css';

let periodOptions = [];

function findReportablePeriods() {
  const now = new Date();
  const currentYear = now.getFullYear();
  // const progress = 0; // Placeholder for progress, to be calculated later

  // Find current and previous 5 quarters
  {
    let QuartersToAdd = 6;
    let QuartersAdded = 0;
    let CurrentPeriod = new Date(now);

    let StartOfQuarter = new Date(now);
    let EndOfQuarter = new Date(now);
    CurrentPeriod.setHours(0, 0, 0, 0); // Reset time to midnight

    while (QuartersAdded < QuartersToAdd) {
      let month = CurrentPeriod.getMonth();
      let CurrentQ;
      if (month >= 0 && month < 3) {
        CurrentQ = 1;
        StartOfQuarter = new Date(CurrentPeriod.getFullYear(), 0, 1);
        EndOfQuarter = new Date(CurrentPeriod.getFullYear(), 2, 31);
      } else if (month >= 3 && month < 6) {
        CurrentQ = 2;
        StartOfQuarter = new Date(CurrentPeriod.getFullYear(), 3, 1);
        EndOfQuarter = new Date(CurrentPeriod.getFullYear(), 5, 30);
      } else if (month >= 6 && month < 9) {
        CurrentQ = 3;
        StartOfQuarter = new Date(CurrentPeriod.getFullYear(), 6, 1);
        EndOfQuarter = new Date(CurrentPeriod.getFullYear(), 8, 30);
      } else if (month >= 9 && month < 12) {
        CurrentQ = 4;
        StartOfQuarter = new Date(CurrentPeriod.getFullYear(), 9, 1);
        EndOfQuarter = new Date(CurrentPeriod.getFullYear(), 11, 31);
      }
      // FIX: value is now a string, not an array
      const valueStr = `Q${CurrentQ}-${StartOfQuarter.getFullYear()}`;
      const labelStr = `Q${CurrentQ} ${StartOfQuarter.getFullYear()}`;
      const Visible = (QuartersAdded === QuartersToAdd - 1) ? true : false;
      periodOptions.push({
        value: valueStr,
        label: labelStr,
        start: StartOfQuarter,
        end: EndOfQuarter,
        hidden: Visible
      });
      CurrentPeriod.setMonth(CurrentPeriod.getMonth() - 3);
      QuartersAdded = QuartersAdded + 1;
    }
  }

  // Add FY entries
  {
    // Find the last April 1st (could be this year or last year)
    let start = new Date(currentYear - 3, 3, 1); // April is month 3 (0-based)
    if (now < start) {
      start = new Date(currentYear - 4, 3, 1);
    }
    // Loop every 12 months from start to now
    let loopDate = new Date(start);

    console.log("Start date for FY loop: ", start);
    console.log("Loop date for FY loop: ", loopDate);

    let fyCount = 0; // Track how many FYs we've added

    while (loopDate <= now) {
      let startofFY = new Date(loopDate);
      const fyValue = `FY-${startofFY.getFullYear()}`;
      const fyLabel = `FY ${startofFY.getFullYear()}`;
      // Set hidden true for the first FY, false for others
      const Visible = fyCount === 0 ? true : false;
      periodOptions.push({
        value: fyValue,
        label: fyLabel,
        start: startofFY,
        end: new Date(loopDate.getFullYear() + 1, 2, 31), // End of March next year
        hidden: Visible
      });
      loopDate.setFullYear(loopDate.getFullYear() + 1);
      fyCount++;
    }
  }
  // console.log("all options are now: ", periodOptions);
}

findReportablePeriods();

// function getCurrentQuarterValue() {
//   const currentDate = new Date();
//   const currentMonth = currentDate.getMonth(); // 0-11
//   const currentYear = currentDate.getFullYear();
//   let currentQuarter;
//   if (currentMonth <= 2) currentQuarter = "Q1";
//   else if (currentMonth <= 5) currentQuarter = "Q2";
//   else if (currentMonth <= 8) currentQuarter = "Q3";
//   else currentQuarter = "Q4";
//   return `${currentQuarter} ${currentYear}`;
// }

function getCurrentFY() {
  // Find the FY entry for the current year
  const fy = periodOptions.find(opt => opt.value.startsWith('FY-') && opt.value.includes(new Date().getFullYear()));
  if (fy) return fy.value;
  // fallback to first FY or first option
  const firstFY = periodOptions.find(opt => opt.value.startsWith('FY-'));
  return firstFY ? firstFY.value : (periodOptions[0]?.value || "");
}

function getProgressBarStyle(progress) {
  if (progress <= 50) {
    return { backgroundColor: '#2ecc71' }; // green
  } else if (progress <= 75) {
    return { backgroundColor: '#ffc107' }; // amber
  } else if (progress <= 90) {
    return { backgroundColor: '#e74c3c' }; // red
  } else {
    // striped red and amber
    return {
      backgroundImage: 'repeating-linear-gradient(135deg, #e74c3c, #e74c3c 10px, #ffc107 10px, #ffc107 20px)',
      backgroundSize: '30px 40px'
    };
  }
}

function Sales() {
  const navigate = useNavigate();
  // Fix: previousPeriod should be null or an object, not an array
  const [previousPeriod, setPreviousPeriod] = useState(periodOptions.find(opt => opt.value.startsWith('FY-') && opt.value.includes(new Date().getFullYear()-1)));
  const [selectedPeriod, setSelectedPeriod] = useState(periodOptions.find(opt => opt.value === getCurrentFY()));
  const [headerText, setHeaderText] = useState(
    `Performance overview for ${selectedPeriod.label || "UNABLE TO FIND CURRENT PERIOD1"}`
  );
  // taxProgress should be a number, not JSX
  const [taxProgress, setCurrentRevenue] = useState(10);
  const [previousRevenue, setPreviousRevenue] = useState(0);
  const [revenueDifferenceContent, setRevenueDifferenceContent] = useState('Loading...');
  const [topSellingProducts, setTopSellingProducts] = useState([]);
  const [topCustomers, setTopCustomers] = useState([]);
  const [newCustomers, setNewCustomers] = useState(null);
  const [avgDealSize, setAvgDealSize] = useState(null);


  useEffect(() => {
    if (Globals.LoginTime === null) {
      navigate('/login');
    }
  }, [navigate]);

  useEffect(() => {
    const selectedLabel = selectedPeriod.label || "UNABLE TO FIND CURRENT PERIOD2";
    setHeaderText(`Performance overview for ${selectedLabel} with the start of the period on ${selectedPeriod.start.toLocaleDateString()} and the end of the period on ${selectedPeriod.end.toLocaleDateString()}`);
  }, [selectedPeriod]);

  useEffect(() => {
    if (!selectedPeriod) return;
    //console.log("Searching revenue for period: ", selectedPeriod.start, " to ", selectedPeriod.end);
    // Fetch current total sales revenue with POST request
    apiClient.post('/api/sales/revenue', { start: selectedPeriod.start.toISOString(), end: selectedPeriod.end.toISOString() })
      .then(data => {
        setCurrentRevenue(data.totalRevenue);
          let prevPeriod = null;
        if(selectedPeriod.value.startsWith('FY-')) {
          prevPeriod = periodOptions.find(opt => opt.value === `FY-${selectedPeriod.value.split('-')[1] - 1}`);
          setPreviousPeriod(prevPeriod || null);
        } else {
          const secondChar = selectedPeriod.value.charAt(1);
          if(secondChar > 1){
            prevPeriod = periodOptions.find(opt => opt.value === `Q${secondChar-1}-${selectedPeriod.value.split('-')[1]}`);
          } else {
            prevPeriod = periodOptions.find(opt => opt.value === `Q4-${selectedPeriod.value.split('-')[1] - 1}`);
          }
          setPreviousPeriod(prevPeriod || null);
        }
      })
      .catch(() => setCurrentRevenue('Error'));
  }, [selectedPeriod]);




  useEffect(() => {
      apiClient.post('/api/sales/revenue', { start: previousPeriod.start.toISOString(), end: previousPeriod.end.toISOString() })
      .then(data => {
        setPreviousRevenue(data.totalRevenue);
        console.log("Previous revenue for period: ", previousPeriod.start, " to ", previousPeriod.end, " is: ", data.totalRevenue);
      })
      .catch(() => setPreviousRevenue('Error'));
  }, [previousPeriod]);

  useEffect(() => {
    const percentChange = (((taxProgress - previousRevenue) / previousRevenue) * 100).toFixed(2);
    let isPositive = '';
    isPositive = (taxProgress - previousRevenue)>0;
    let content = 'Loading...';
    console.log("taxProgress: ", taxProgress, " previousRevenue: ", previousRevenue, " percentChange: ", percentChange, " isPositive: ", isPositive);
    if (taxProgress === previousRevenue) {
      content = 'No change vs prev quarter';
      isPositive = "neutral";
    } else
    if (previousRevenue.toString() === "0" || taxProgress.toString() === "0") {
      content = 'lack of revenue data';
      isPositive = "neutral";
    } else
    if (isPositive) {
      content = `↑ ${percentChange}% vs prev quarter`;
    } else {
      content = `↓ ${percentChange}% vs prev quarter`;
    }

    console.log(isPositive);
    
    setRevenueDifferenceContent({ "type": isPositive, "content": content });
  }, [taxProgress, previousRevenue]);

  // Optional: log previousPeriod when it changes
  useEffect(() => {
    if (previousPeriod) {
      console.log("Previous period:", previousPeriod.value, "from", previousPeriod.start.toLocaleDateString(), "to", previousPeriod.end.toLocaleDateString());
    } else {
      console.log("Previous period: none");
    }
  }, [previousPeriod]);

  useEffect(() => {
    console.log("top Selected period:", selectedPeriod.value, "from", selectedPeriod.start.toLocaleDateString(), "to", selectedPeriod.end.toLocaleDateString());
    apiClient.post('/api/purchases/topSelling', { start: selectedPeriod.start.toISOString(), end: selectedPeriod.end.toISOString() })
      .then(data => {
        setTopSellingProducts(Array.isArray(data) ? data : []);
        console.log("Top selling products fetched:", data);
      })
      .catch(() => setTopSellingProducts([]));
  }, [selectedPeriod]);

  useEffect(() => {
    if (!selectedPeriod) return;
    const body = { start: selectedPeriod.start.toISOString(), end: selectedPeriod.end.toISOString() };

    apiClient.post('/api/sales/topCustomers', body)
      .then(data => setTopCustomers(Array.isArray(data.results) ? data.results : []))
      .catch(() => setTopCustomers([]));

    apiClient.post('/api/sales/newCustomers', body)
      .then(data => setNewCustomers(typeof data.newCustomers === 'number' ? data.newCustomers : null))
      .catch(() => setNewCustomers(null));

    apiClient.post('/api/sales/avgDealSize', body)
      .then(data => setAvgDealSize(typeof data.avgDealSize === 'number' ? data.avgDealSize : null))
      .catch(() => setAvgDealSize(null));
  }, [selectedPeriod]);

  // Calculate progress percentage for the progress bar
  const progress = taxProgress && !isNaN(taxProgress)
    ? Math.min((taxProgress / 1000) * 100, 100)
    : 0;

  return (
    <div>
      <Navbar />
      <Sidebar />
      <div className={styles.mainContent}>
        <div className={styles.dashboard}>
          <br />
          <br />
          <header className={styles.header}>
            <div>
              <h1>Sales Rocket Dashboard</h1>
              <p>{headerText}</p>
            </div>
            <div className={styles.dateSelector}>
              <span>Period:</span>
              <select
                id="periodSelector"
                value={selectedPeriod.value}
                onChange={e => {
                  const selected = periodOptions.find(opt => opt.value === e.target.value);
                    setSelectedPeriod(selected);
                  }}
                  >
                  {periodOptions
                    .filter(opt => !opt.hidden)
                    .map(opt => (
                    <option key={opt.value} value={opt.value}>{opt.label}</option>
                    ))}
                  </select>
                </div>
                </header>

                <div className={styles.kpiContainer}>
                <div className={styles.kpiCard}>
                  <h3>Total Revenue</h3>
                  <p><i>All money into the bank account during the {selectedPeriod.label} {selectedPeriod.label.startsWith("FY") ? "year" : "quarter"}</i></p>
                  <div className={styles.kpiValue}>£{taxProgress !== null && taxProgress !== 'Error' ? taxProgress : '...'}</div>
                  <div className={
  `${styles.kpiChange} ${
    String(revenueDifferenceContent.type) === "true"
      ? styles.positive
      : String(revenueDifferenceContent.type) === "neutral"
        ? styles.neutral
        : styles.negative
  }`}>
                  {revenueDifferenceContent.content}
                  </div>
                </div>
                <div className={styles.kpiCard}>
                  <h3>New Customers</h3>
                  <p><i>Customer accounts created during {selectedPeriod.label}</i></p>
                  <div className={styles.kpiValue}>{newCustomers !== null ? newCustomers : '...'}</div>
                </div>
                <div className={styles.kpiCard}>
                  <h3>Avg Deal Size</h3>
                  <p><i>Total revenue divided by number of orders in the period</i></p>
                  <div className={styles.kpiValue}>{avgDealSize !== null ? `£${avgDealSize.toFixed(2)}` : '...'}</div>
                </div>
                <div className={styles.kpiCard}>
                  <h3>Sales Conversion</h3>
                  <p><i>Not available - no lead/opportunity tracking exists yet</i></p>
                  <div className={styles.kpiValue}>N/A</div>
                </div>
                </div>

                <div className={styles.fiscalYearContainer}>
                <div className={styles.chartContainer}>
                  <h1>Tax Check</h1>
                  <p className={styles.salesAmount}>
                  Current Total Sales: £{taxProgress !== null && taxProgress !== 'Error' ? taxProgress : '...'}
                  </p>
                  <div className={styles.progressBar}>
                  <div
                    className={styles.progress}
                    style={{
                    width: `${progress}%`,
                    ...getProgressBarStyle(progress)
                    }}
                  ></div>
                  </div>
                  <p className={styles.goal}>£1000 Goal</p>
                </div>
                </div>
                <br />
                <div className={styles.fiscalYearContainer}>
                <div className={styles.tableContainer}>
                  <h1>Costs:</h1>
                  <div className={styles.secondaryCharts}>
                  <div className={styles.tableContainer}>
                    <h2>Fixed operating costs</h2>
                    <h4><i>These are only paid once per year</i></h4>
                    <table>
                    <thead>
                      <tr>
                      <th>Description</th>
                      <th>Cost</th>
                      <th>Frequency</th>
                      <th>Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                      <td>(HARD CODED)HOSTING</td>
                      <td>£130</td>
                      <td>Annual</td>
                      <td>£130</td>
                      </tr>
                    </tbody>
                    </table>
                  </div>
                  <div className={styles.tableContainer}>
                    <h2>Annual Outgoings</h2>
                    <table>
                    <thead>
                      <tr>
                      <th>Description</th>
                      <th>Cost</th>
                      <th>Frequency</th>
                      <th>Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                      <td>(HARD CODED)Monthly cost</td>
                      <td>£3.99</td>
                      <td>Monthly</td>
                      <td>£47.88</td>
                      </tr>
                    </tbody>
                    </table>
                  </div>
                  </div>
                </div>
                </div>
                <br />
                <div className={styles.mainCharts}>
                <div className={styles.chartContainer}>
                  <h2>Monthly Sales Performance</h2>
                  <p><i>Chart not built yet - needs revenue aggregated by month</i></p>
            </div>
            <div className={styles.chartContainer}>
              <h2>Sales by Category</h2>
              <p><i>Chart not built yet - needs revenue aggregated by product category</i></p>
            </div>
          </div>

          <div className={styles.secondaryCharts}>
        <div className={styles.tableContainer}>
          <h2>Top Selling Products</h2>
          <table>
            <thead>
              <tr>
                <th>Product Name</th>
                <th>Category</th>
                <th>Units</th>
                <th>Revenue</th>
              </tr>
            </thead>
            <tbody>
              {topSellingProducts.length > 0 ? (
                topSellingProducts.map((product, idx) => (
                  <tr key={product.id || idx}>
                    <td>{product.product_name}</td>
                    <td>{product.product_type}</td>
                    <td>{product.count}</td>
                    <td>{`£${product.total_line_item_price}`}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={4}>No data available</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
            <div className={styles.tableContainer}>
              <h2>Top Customers</h2>
              <table>
                <thead>
                  <tr>
                    <th>Customer</th>
                    <th>Revenue ({selectedPeriod.label})</th>
                  </tr>
                </thead>
                <tbody>
                  {topCustomers.length > 0 ? (
                    topCustomers.map((customer) => (
                      <tr key={customer.userId}>
                        <td>{customer.name}</td>
                        <td>£{customer.revenue.toFixed(2)}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={2}>No customer revenue in this period</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>

          <div className={styles.chartContainer}>
            <h2>Sales Team Performance</h2>
            <p><i>Not applicable yet - invoices/purchases don't track an assigned salesperson</i></p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Sales;